<section class="container py-5 " *ngIf="!policyPaymentDetailes?.isError">
  <div class="text-center py-5 grid-shadow1 px-3">
    <div class="text-center text-success mb-3">
      <i class="fa-regular fa-thumbs-up successFailurIcons"></i>
    </div>
    <div class="header">
      <h4 class="heading3">Travel Insurance - Policy Confirmation</h4>
    </div>
    <div class="section">
      <div class="heading2">Thank You for Choosing Us!</div>
      <p>We truly appreciate your decision to choose our travel insurance. Your policy document has been sent to your
        email. Below is your policy number.</p>
    </div>
    <div class="section">
      <!-- <div class="heading2 mb-2">Policy Details</div> -->
      <p><strong>Policy Number :</strong> {{policyPaymentDetailes?.policyNo}}</p>
      <p><strong>Reference Number :</strong> {{policyPaymentDetailes?.referenceNumber}}</p>
      <div>
        <!-- <button class="button1 me-3 mb-2">Download Policy <i class="fa-solid fa-cloud-arrow-down"></i></button> -->
        <button class="button1  mb-2" [routerLink]="['/policy/my-policy']">Go to My Policy</button>
      </div>
    </div>
  </div>
</section>

<section class="container py-5 " *ngIf="policyPaymentDetailes?.isError">
  <div class="text-center py-5 grid-shadow1 px-3">
    <p class="text-center mb-3"><i class="fa-solid fa-thumbs-down text-danger successFailurIcons"></i></p>
    <div class="section">
      <p>{{policyPaymentDetailes?.errorMessage || ''}}</p>
      <p><strong>Reference Number :</strong> {{policyPaymentDetailes?.referenceNumber}}</p>
      <div>
        <button class="button1  mb-2" [routerLink]="['/home']">Back to home</button>
      </div>
    </div>
  </div>
</section>